document.addEventListener('DOMContentLoaded', function () {
  document.body.appendChild(
    document.body.querySelector('template#product-sticky-bundle-picker-tmpl')
      ?.content
      ?.firstElementChild.cloneNode(true)
  );
});
class StickyBundlePicker extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.form = this.querySelector('.action form');
    this.formInput = this.form.querySelector('input[name="selected-bundle-id"]');
    this.formProductInput = this.form.querySelector('input[name="selected-product-id"]');
    this.formSubmitBtn = this.form.querySelector('button[type="submit"]');
    this.optionList = this.querySelectorAll('.product-variant-options li');
    this.infoContainer = this.querySelector('.info');
    this.stickyContainer = this.querySelector('.sticky-bundle-picker-container');
    this.selectedBundleImage = this.infoContainer.querySelector('.product-variant-selected .product-image');
    this.selectedBundleInfo = this.infoContainer.querySelector('.product-variant-selected .product-info');
    this.init();
  }

  init() {
    const _this = this;
    this.querySelector('.toggle-option')
      ?.addEventListener('click', this.showBundlePickerOption.bind(this));
    this.querySelectorAll('.select-option').forEach(
      option => {
        option.addEventListener('change', function (e) {
          _this.handleSelectOption(e.target.closest('li'));
          _this.toggleBundleOption(false);
        })
      }
    );
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    // Close option list when clicking outside
    document.addEventListener("click", function (event) {
      if (!_this.contains(event.target)) {
        _this.toggleBundleOption(false);
      }
    });
    this.optionList.forEach(option => {
      option.addEventListener('click', function () {
        let input = option.querySelector('input');
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      })
    });
    // Pre-select the first option on page load
    if (this.optionList.length > 0) {
      const preselected = this.optionList[0].querySelector('input');
      preselected.checked = true;
      preselected.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Show stick bar on scroll down
    window.addEventListener("scroll", debounce(() => {
      let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
      let windowHeight = window.innerHeight;
      if (scrollPosition > windowHeight && !_this.stickyContainer.classList.contains('show')) {
        _this.stickyContainer.classList.add('show')
      } else if (scrollPosition < windowHeight && _this.stickyContainer.classList.contains('show')) {
        _this.stickyContainer.classList.remove('show')
      }
    }, 300))
  }

  showBundlePickerOption() {
    this.toggleBundleOption(!this.infoContainer.classList.contains('option-opened'));
  }

  toggleBundleOption(active) {
    this.infoContainer.classList.toggle('option-opened', active)
  }

  handleSelectOption(item) {
    if (!item || item?.tagName !== 'LI') return;
    this.formInput.value = item.dataset.variantId;
    this.formProductInput.value = item.dataset.productId;
    this.selectedBundleImage.innerHTML = item.querySelector('.product-image').innerHTML;
    this.selectedBundleInfo.innerHTML = item.querySelector('.product-info').innerHTML;
    this.optionList.forEach(option => {
      option.classList.remove('selected');
    });
    setTimeout(() => item.classList.add('selected'), 100);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.formSubmitBtn.setAttribute('aria-disabled', true);
    this.formSubmitBtn.classList.add('loading');
    this.form.querySelector('.loading__spinner').classList.remove('hidden');
    this.formSubmitBtn.disabled = true;
    let config = fetchConfig('javascript'), formData = new FormData(this.form)
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }
    formData.set('id', this.formInput.value);
    formData.set('product-id', this.formProductInput.value);
    formData.delete('selected-bundle-id');
    formData.delete('selected-product-id');
    delete config.headers['Content-Type'];
    config.body = formData;
    this._addToCart(config)
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          productVariantId: formData.get('id'),
          cartData: data,
        });
        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
          this.cart.renderContents(data);
        }
      }).catch((error) => console.error('Error adding selected bundle item to cart:', error))
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.formSubmitBtn.setAttribute('aria-disabled', false);
        this.formSubmitBtn.classList.remove('loading');
        this.form.querySelector('.loading__spinner').classList.add('hidden');
        this.formSubmitBtn.disabled = false;
      });
  }

  _addToCart(config) {
    return fetch(`${routes.cart_add_url}`, config).then((response) => {
      if (!response.ok) throw new Error('Failed to add the selected bundle to cart');
      return response.json();
    });
  }
}

customElements.define('sticky-bundle-picker', StickyBundlePicker);
